// Module
var code = "<div> <section class=\"heading\"> <div class=\"row no-gutter\"> <ng-include src=\"'/dashboard/nav.html'\"></ng-include> </div> </section> <payment-schedules-dashboard current-user=\"currentUser\" on-error=\"onError\" on-card-update-success=\"onCardUpdateSuccess\"/> </div> ";
// Exports
var _module_exports = code;;
var path = '/dashboard/payment_schedules.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;